import {Component} from 'panel';

import {PROPERTIES} from 'common/report/constants';
import {registerMPElement} from 'common/util/register-element';

import {trackAlertEvent} from '../utils/tracking';

import template from './index.jade';

class SmartHubExplains extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      property: `string`,
      'property-value': `string`,
    };
  }

  get config() {
    return {
      template,
      helpers: {
        handleClickSegmentsLink: (ev, segment) => {
          ev.stopPropagation();

          const {property, propertyType, propertyValue, priority} = segment;

          const navigateToLink = () => {
            const href = ev.currentTarget.href;
            const modifierKey = ev.ctrlKey || ev.metaKey;

            if (!modifierKey) {
              ev.preventDefault();
              window.location.href = href;
            }
          };

          trackAlertEvent(`Smart Hub: Clicked Explain`, this.app.getAlert(), this.app.context, {
            explain_property: property,
            explain_value: propertyValue,
            explain_priority: priority,
            explain_type: propertyType,
          }).then(navigateToLink);

          // Navigate to link if the mixpanel track calls doesn't finish within 300ms.
          setTimeout(navigateToLink, 300);
        },
        getIcon: (explains) => {
          if (explains.propertySegmentsDetail) {
            return this.propertyTypeToIcon[explains.propertyType];
          } else {
            return `profile`;
          }
        },
        getFormattedProperty: (property) => {
          if (property in PROPERTIES) {
            return PROPERTIES[property];
          } else {
            return property;
          }
        },
        isSelectedExplains: (segment) => {
          return (
            this.explainsProperty === segment.property && this.explainsPropertyValue === String(segment.propertyValue)
          );
        },
        getSegmentStrength: (priority) => {
          return priority < 0.5 ? `weak` : `strong`;
        },
        getSegmentsType: () => {
          // A series of segments will only ever be of one type
          // For example, you'll never have an anomalousUsersDetail AND a propertySegmentsDetail key in a
          // single segment
          const pluralTypes = {Property: `Properties`, User: `Users`};
          const segmentsType = this.alert.explains[0].propertySegmentsDetail ? `Property` : `User`;
          return this.hasMultipleSegments ? pluralTypes[segmentsType] : segmentsType;
        },
        getSegmentsMessage: () => {
          const verb = this.hasMultipleSegments ? `are` : `is`;
          return `${verb} contributing to this anomaly`;
        },
      },
    };
  }

  get projectId() {
    return this.appState.projectId;
  }

  get alert() {
    return this.app.getAlert();
  }

  get explainsProperty() {
    return this.attr(`property`);
  }

  get explainsPropertyValue() {
    return this.attr(`property-value`);
  }

  get propertyTypeToIcon() {
    return {
      STRING: `type-text`,
      BOOLEAN: `type-boolean`,
      NUMBER: `type-number`,
    };
  }

  get hasMultipleSegments() {
    return this.alert.explains.length > 1;
  }
}

export default registerMPElement(`mp-smart-hub-explains`, SmartHubExplains);
